webpackJsonp([58447293763160],{

/***/ 1593:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpdateStockTransferReportRecipientInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"email","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-update-stock-transfer-report-recipient-input-93f75a403ae2d93948e1.js